import React from 'react';
import { AdminLayout } from 'src/Layouts';
import { useParams } from 'react-router-dom';
import { Container, ContentGrid, ConversationsContainer, } from 'src/Views/TicketDetails/styles';
import TicketDetailsHeader from 'src/Components/Tickets/TicketDetailsHeader';
import TicketInformation from 'src/Components/Tickets/TicketInformation/TicketInformation';
import TicketRightPanel from 'src/Components/Tickets/TicketRightPanel/TicketRightPanel';
import TicketContactInfo from 'src/Components/Tickets/TicketContactInfo/TicketContactInfo';
import ExternalConversation from 'src/Components/Tickets/ExternalConversation';
import { useTicket } from 'src/hooks/useTicket';
var ClientTicketDetails = function () {
    var _a, _b;
    var id = useParams().id;
    var _c = useTicket(id ? parseInt(id) : null), ticket = _c.ticket, loading = _c.loading, error = _c.error;
    var displayError = error
        ? error.replace(/ticket/gi, 'reclamo')
        : 'Reclamo no encontrado';
    if (loading) {
        return (React.createElement(AdminLayout, null,
            React.createElement(Container, null,
                React.createElement("div", null, "Cargando reclamo..."))));
    }
    if (error || !ticket) {
        return (React.createElement(AdminLayout, null,
            React.createElement(Container, null,
                React.createElement("div", null, displayError))));
    }
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(TicketDetailsHeader, { ticketNumber: ticket.ticket_number.toString(), entityLabel: "Reclamo", status: ticket.status, building: ((_a = ticket.building) === null || _a === void 0 ? void 0 : _a.name) || '', apartment: (_b = ticket.apartment) === null || _b === void 0 ? void 0 : _b.number, date: ticket.created_at
                    ? new Date(ticket.created_at).toLocaleDateString()
                    : '', service: ticket.provider_service, showNotifyCheckbox: false, onCompleteTicket: function () { }, hideCompleteButton: true }),
            React.createElement(ContentGrid, null,
                React.createElement(TicketInformation, { ticket: ticket, isReadOnly: true }),
                React.createElement(TicketRightPanel, { ticket: ticket, fullHeight: true },
                    React.createElement(TicketContactInfo, { ticket: ticket, matchTicketInformationStyle: true }))),
            React.createElement(ConversationsContainer, null,
                React.createElement(ExternalConversation, { ticket: ticket, fullWidth: true })))));
};
export default ClientTicketDetails;
